export default "__VITE_ASSET__e768cfa0__"